import {Component, Input, OnInit} from '@angular/core';
export class CbjCardTabComponent implements OnInit {
   title: string;
   active = false;
   icon: boolean | string = false;
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cbj-card-tab',
  template: '<div [hidden]="!active"><ng-content></ng-content></div>'

}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'title': [{ type: Input, args: ['title', ] },],
'active': [{ type: Input },],
'icon': [{ type: Input, args: ['icon', ] },],
};
}

function CbjCardTabComponent_tsickle_Closure_declarations() {
/** @type {?} */
CbjCardTabComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjCardTabComponent.ctorParameters;
/** @type {?} */
CbjCardTabComponent.propDecorators;
/** @type {?} */
CbjCardTabComponent.prototype.title;
/** @type {?} */
CbjCardTabComponent.prototype.active;
/** @type {?} */
CbjCardTabComponent.prototype.icon;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
